var _a;
import { PlanCategoryType } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
export var enumDescriptionMap = (_a = {},
    _a[PlanCategoryType.Behavioral] = 'Behavioral',
    _a[PlanCategoryType.DentalCare] = 'Dental care',
    _a[PlanCategoryType.MedicalBehavioral] = 'Medical behavioral',
    _a[PlanCategoryType.MedicalCare] = 'Medical care',
    _a[PlanCategoryType.Pharmacy] = 'Pharmacy',
    _a[PlanCategoryType.VisionCare] = 'Vision care',
    _a);
export var PlanCategoryTypeEnum = {
    name: 'PlanCategoryType',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
